import {
  Paragraph,
  TextRun,
} from "docx"

export const renderCertificateSection = certificateExperiences => {
  if (!certificateExperiences || certificateExperiences.length === 0) {
    return []
  }

  return [
    new Paragraph({
      children: [
        new TextRun({
          text: "LICENSES AND CERTIFICATIONS",
          bold: true,
          size: 21,
        }),
      ],
      spacing: {
        before: 200,
      },
      border: {
        bottom: {
          color: "#d3d3d3",
          space: 1,
          style: "single",
          size: 6,
        },
      },
    }),
    ...certificateExperiences
      .map(experience => {
        const {
          title = "CERTIFICATE TITLE",
          issuer = "SCHOOL",
          bulletPoints = [],
          endDate = "",
        } = experience

        return [
          new Paragraph({
            spacing: {
              before: 50,
            },
            children: [
              new TextRun({
                text: title,
                bold: true,
                size: 21,
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: `${issuer}${issuer && endDate && " | "}${endDate}`,
                size: 20,
              }),
            ],
          }),
          ...bulletPoints.map(bulletPoint =>
            new Paragraph({
              bullet: {
                level: 0,
              },
              children: [
                new TextRun({
                  text: bulletPoint,
                  font: "cambria",
                  size: 20,
                }),
              ],
            })
          )
        ]
      })
      .flat(),
  ]
}
